// パスワード入力欄の表示/非表示を切り替える。
// snippets/password-toggle.liquid が出力するボタンをイベント委譲で拾う。
(function () {
  if (window.passwordToggleInitialized) return;
  window.passwordToggleInitialized = true;

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.password-toggle');
    if (!toggle) return;

    const input = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!input) return;

    const willShow = input.type === 'password';
    input.type = willShow ? 'text' : 'password';
    toggle.setAttribute('aria-pressed', willShow ? 'true' : 'false');
    toggle.setAttribute('aria-label', willShow ? 'パスワードを非表示' : 'パスワードを表示');
  });
})();
